import { parseReference } from "@/lib/norwegianLawLinks";
import { ExternalLink } from "lucide-react";

/**
 * Renders a question reference string with the law name as a clickable link
 * to the official Lovdata / Statens vegvesen source.
 */
export default function ReferenceLink({ reference, className = "" }) {
  if (!reference) return null;

  const [segment] = parseReference(reference);

  return (
    <p
      data-testid="question-reference"
      className={`mt-2 text-xs text-gray-500 italic border-t border-gray-200 pt-2 flex items-start gap-1 ${className}`}
    >
      <span>📖</span>
      {segment.url ? (
        <a
          href={segment.url}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-blue-600 hover:underline inline-flex items-center gap-0.5 transition-colors"
          title={`Open ${segment.label}`}
        >
          {segment.text}
          <ExternalLink className="w-3 h-3 shrink-0 opacity-60" />
        </a>
      ) : (
        <span>{segment.text}</span>
      )}
    </p>
  );
}
